import { TransformPluginConfigs } from './transform-plugin-configs';

/**
 * This function is used to evaluate the plugin configuration for the Bitmovin Analytics Plugin.
 *
 * @remarks
 * The plugin should be disabled. In certain test cases the plugin may be enabled via the remote configuration,
 * to cross-check the data tracked by Bitmovin and NPAW.
 *
 * Bitmovin reports download data, which is not available as a public API, and is thus only available via their analytics.
 *
 * Be aware that our contract for Bitmovin Analytics is about to expire and will not be renewed.
 */
export const addBitmovinAnalyticsPlugin: TransformPluginConfigs = (partialBuilderConfig, pluginConfigs) => {
  const bitmovinAnalytics = 'foundation.plugin.bitmovinAnalytics';
  const { remoteConfig } = partialBuilderConfig;

  const enabled =
    typeof pluginConfigs[bitmovinAnalytics]?.enabled === 'boolean'
      ? pluginConfigs[bitmovinAnalytics].enabled
      : remoteConfig.bitmovinAnalytics?.enable;

  if (!enabled) {
    return pluginConfigs;
  }

  const key = pluginConfigs[bitmovinAnalytics]?.key || remoteConfig.bitmovinAnalytics?.licenseKey;

  if (!key) {
    return {
      ...pluginConfigs,
      [bitmovinAnalytics]: undefined,
    };
  }

  return {
    ...pluginConfigs,
    [bitmovinAnalytics]: {
      ...pluginConfigs[bitmovinAnalytics],
      key,
      enabled: true,
    },
  };
};
